import React, { useEffect } from "react";

export default function FirstPost() {
  useEffect(() => {
    const handleContextMenu = e => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    const handleKeyDown = e => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "C" || e.key === "J")) ||
        (e.metaKey && e.altKey && e.key.toLowerCase() === "i") ||
        (e.ctrlKey && e.key.toLowerCase() === "u")
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <article style={{ maxWidth: 700, margin: '0 auto', padding: '2rem 0' }}>
      <div style={{
        textAlign: "center",
        padding: "4rem 2rem",
        color: "#718096",
        fontSize: "1.2rem"
      }}>
        <div style={{
          fontSize: "3rem",
          marginBottom: "1rem",
          opacity: 0.3
        }}>
          🚧
        </div>
        <h3 style={{ 
          color: "var(--text-color)", 
          marginBottom: "0.5rem",
          fontWeight: 500
        }}>
          Coming Soon
        </h3>
        <p style={{ margin: 0 }}>
          This post is currently under construction. Check back soon!
        </p>
      </div>
    </article>
  );
} 